<template>
  <div class="microbiology-filter width-responsiveness">
    <card-form :collapsed="true">
      <div
        slot="expanded"
        class="form-container"
      >
        <md-layout
          :md-gutter="24"
          md-flex="100"
          style="gap: 20px 0"
        >
          <md-layout
            md-flex="100"
            md-flex-medium="100"
          >
            <h2 class="orders-new__doctor__title title-main">FILTROS</h2>
          </md-layout>

          <md-layout
            md-flex="45"
            md-flex-medium="50"
          >
            <SearchFieldSelector
              :default-start-date="defaultStartDate"
              :default-end-date="defaultEndDate"
              :options="dateSelectOptions"
              :clean-date="cleanDate"
              @updateSearchValue="handleSearchValueUpdate"
            />
          </md-layout>

          <md-layout
            md-flex="45"
            md-flex-medium="50"
          >
            <SearchFieldSelector
              :options="searchOptions"
              @updateSearchValue="handleSearchValueUpdate"
            />
          </md-layout>

          <md-layout
            md-flex="100"
            class="actions-row"
          >
            <md-checkbox
              v-model="filter.onlyPositive"
              class="checkbox-positive"
            >
              Apenas resultados positivos
            </md-checkbox>

            <button
              :disabled="loading"
              class="btn btn-primary btn-search"
              @click="handleSearch"
            >
              <md-icon
                md-src="/static/images/icon-search.svg"
                class="icon-search"
              >
                search
              </md-icon>
              Buscar
            </button>
          </md-layout>
        </md-layout>
      </div>
    </card-form>
    <div class="microbiology-filter__tabs">
      <div
        class="microbiology-filter__tab"
        :class="{ 'microbiology-filter__tab--active': currentTab === 'ALL' }"
        @click="handleTabClick('ALL')"
      >
        Todos
      </div>
      <div
        class="microbiology-filter__tab"
        :class="{ 'microbiology-filter__tab--active': currentTab === 'IN_PROGRESS' }"
        @click="handleTabClick('IN_PROGRESS')"
      >
        Em Andamento
      </div>
      <div
        class="microbiology-filter__tab"
        :class="{ 'microbiology-filter__tab--active': currentTab === 'FINISHED' }"
        @click="handleTabClick('FINISHED')"
      >
        Finalizados
      </div>
    </div>
  </div>
</template>

<script>
import CardForm from '@/components/common/CardForm'
import SearchFieldSelector from '@/components/common/SearchFieldSelector'
import Moment from 'moment'
import notify from '@/api/notification'

export default {
  name: 'MicrobiologyFilter',
  components: {
    CardForm,
    SearchFieldSelector,
  },
  data() {
    return {
      filter: {
        orderId: '',
        orderLisId: '',
        patientName: '',
        startDate: '',
        endDate: '',
        mnemonic: '',
        onlyPositive: false,
      },
      cleanDate: 0,
      loading: false,
      currentTab: 'ALL',
      searchOptions: [
        {
          value: 'orderId',
          label: 'OS Alvaro',
          placeholder: 'OS Alvaro',
          type: 'text',
          propName: 'orderId',
          selected: true,
        },
        {
          value: 'orderLisId',
          label: 'OS LIS',
          placeholder: 'OS LIS',
          type: 'text',
          propName: 'orderLisId',
          selected: false,
        },
        {
          value: 'patientName',
          label: 'Nome do Paciente',
          placeholder: 'Nome do paciente',
          type: 'text',
          propName: 'patientName',
          selected: false,
        },
        {
          value: 'mnemonic',
          label: 'Exame',
          placeholder: 'Mnemônico',
          type: 'text',
          propName: 'mnemonic',
          selected: false,
        },
      ],
      dateSelectOptions: [
        {
          value: 'date',
          label: 'Data de Cadastro',
          limitDays: 1827,
          singleDate: false,
          selected: true,
          type: 'date',
          propName: 'date',
        },
      ],
    }
  },
  computed: {
    today() {
      return Moment(new Date()).format('DD/MM/YYYY')
    },
    defaultStartDate() {
      return Moment(this.today, 'DD/MM/YYYY').subtract(15, 'days').format('DD/MM/YYYY')
    },
    defaultEndDate() {
      return this.today
    },
  },
  created() {
    this.filter.startDate = this.defaultStartDate
    this.filter.endDate = this.defaultEndDate
    this.handleSearch()
  },
  methods: {
    handleSearchValueUpdate(value) {
      if (value.type === 'date') {
        if (!this.isRangeValid(value.date)) {
          this.cleanDate++
          this.filter.startDate = this.defaultStartDate
          this.filter.endDate = this.defaultEndDate
          notify({
            title: 'AVISO:',
            message: 'Selecione um período de até 30 dias.',
          })
          return
        }
        this.filter.startDate =
          value.date && value.date.start !== ''
            ? Moment(value.date.start).format('DD/MM/YYYY')
            : ''
        this.filter.endDate =
          value.date && value.date.end !== ''
            ? Moment(value.date.end).format('DD/MM/YYYY')
            : ''
      } else {
        this.filter[value.propName] = value.query
      }
    },
    handleSortChange() {
      if (this.hasValidFilter()) {
        this.handleSearch()
      }
    },
    handleTabClick(tab) {
      if (this.loading) return
      this.currentTab = tab
      this.filter.status = tab
      if (this.hasValidFilter()) {
        this.handleSearch()
      }
    },
    handleSearch() {
      if (!this.hasValidFilter()) {
        notify({
          title: 'AVISO:',
          message: 'Por favor, preencha pelo menos um campo de busca.',
        })
        return
      }

      this.$emit('search', {
        orderId: this.filter.orderId,
        orderLisId: this.filter.orderLisId,
        patientName: this.filter.patientName,
        startDate: this.filter.startDate,
        endDate: this.filter.endDate,
        mnemonic: this.filter.mnemonic,
        sort: 'desc',
        onlyPositive: this.filter.onlyPositive,
        status: this.currentTab,
      })
    },
    isRangeValid(date) {
      if (!date || !date.start || !date.end) return true
      return Moment(date.end).diff(Moment(date.start), 'days') <= 30
    },
    hasValidFilter() {
      return (
        this.filter.orderId ||
        this.filter.orderLisId ||
        this.filter.patientName ||
        (this.filter.startDate && this.filter.endDate) ||
        this.filter.mnemonic
      )
    },
  },
}
</script>

<style lang="scss">
.microbiology-filter {
  margin-top: 25px;
  font-family: 'Exo 2', sans-serif !important;

  .card-form__container {
    border-radius: 8px;
    padding-bottom: 18px;

    .search-field-selector {
      .search {
        .search-field-selector__field {
          input {
            color: #363636;
          }
        }
      }
    }

    .actions-row {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-top: 4px;

      .checkbox-positive {
        margin: 0;

        .md-checkbox-label {
          font-family: 'Exo 2', sans-serif;
          font-size: 13px;
          color: #363636;
          font-weight: 500;
        }

        .md-checkbox-container {
          border-color: #7f1a54;

          &::after {
            border-color: #7f1a54;
          }
        }

        &.md-checked .md-checkbox-container {
          background-color: #7f1a54;
          border-color: #7f1a54;
        }
      }
    }

    .box-action {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      padding-left: 0;
    }

    .btn-search {
      width: 100%;
      max-width: 130px;
      text-transform: uppercase;
      font-family: 'Exo 2', sans-serif !important;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 0 4px;
      font-size: 14px;
      gap: 4px;

      .md-icon {
        margin: 0;
      }
    }
  }

  &__title {
    color: #363636;
    font-size: 18px;
    font-weight: 600;
    margin: 0;
  }

  &__sort {
    display: flex;
    flex-direction: column;
    width: 100%;

    .sort-label {
      font-size: 12px;
      color: #999;
      margin-bottom: 4px;
      font-weight: 500;
    }

    .sort-select {
      height: 40px;
      border: 1px solid #ccc;
      border-radius: 4px;
      padding: 8px;
      font-size: 13px;
      color: #363636;
      background-color: #fff;
      font-family: 'Exo 2', sans-serif;

      &:focus {
        outline: none;
        border-color: #7f1a54;
      }
    }
  }

  .micro-chip {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 6px 10px;
    border-radius: 999px;
    font-size: 12px;
    font-weight: 700;
    &--positive {
      background: #ffe6ee;
      color: #b40048;
      border: 1px solid #f5c5d7;
    }
    &--negative {
      background: #e6f7ff;
      color: #1890ff;
      border: 1px solid #91d5ff;
    }
    &--analyzing {
      background: #fff7e6;
      color: #fa8c16;
      border: 1px solid #ffd591;
    }
  }

  .arrow-toggle {
    color: #7a7a7a;
    display: flex;
    align-items: center;
    .md-icon {
      font-size: 20px;
    }
  }

  .timeline {
    &__bar {
      position: relative;
      height: 10px;
      border-radius: 8px;
      background: #f0f0f0;
      margin: 8px 0 16px;
      overflow: hidden;

      .progress {
        height: 100%;
        background: linear-gradient(
          90deg,
          #2a64ff 0 33%,
          #d8a222 33% 66%,
          #b02a3c 66% 100%
        );
        border-radius: 8px;
        transition: width 0.3s ease;
      }
    }

    &__events {
      display: grid;
      grid-template-columns: repeat(5, 1fr);
      gap: 12px;
      margin-top: 8px;
    }

    .event {
      position: relative;
      padding-top: 8px;
    }
    .event__date {
      color: #7a7a7a;
      font-size: 11px;
      display: grid;
      grid-template-columns: auto auto;
      column-gap: 6px;
      align-items: baseline;
      margin-bottom: 6px;
      .year {
        opacity: 0.6;
      }
      .day {
        font-weight: 700;
      }
      .time {
        grid-column: 1 / -1;
      }
    }
    .event__marker {
      width: 18px;
      height: 18px;
      border-radius: 50%;
      border: 3px solid #fff;
      box-shadow: 0 0 0 2px #e6e6e6;
      position: absolute;
      top: -18px;
      left: 0;
    }
    .event__marker.start {
      background: #2a64ff;
    }
    .event__marker.partial {
      background: #d8a222;
    }
    .event__marker.final {
      background: #b02a3c;
    }
    .event__content {
      font-size: 12px;
      color: #303030;
    }
    .event .title {
      font-weight: 700;
      margin-bottom: 2px;
    }
    .title--partial {
      color: #d08a00;
    }
    .title--final {
      color: #b02a3c;
    }
    .event a {
      color: #2a64ff;
      text-decoration: underline;
    }
    .event .subtitle {
      color: #7a7a7a;
      font-size: 11px;
      text-transform: uppercase;
    }
    .event .note {
      margin-top: 2px;
    }
  }

  &__tabs {
    display: flex;
    margin-top: 25px;
    border-bottom: 1px solid #7f1a54;
    background-color: inherit;
  }

  &__tab {
    min-width: 155px;
    text-align: center;
    cursor: pointer;
    color: #979797;
    font-weight: bold;
    font-size: 10px;
    line-height: 12px;
    letter-spacing: 1.3px;
    text-transform: uppercase;
    padding: 12px 18px;
    position: relative;
    top: 1px;

    &--active {
      color: #7f1a54;
      border-top: 1px solid #7f1a54;
      border-left: 1px solid #7f1a54;
      border-right: 1px solid #7f1a54;
      border-top-right-radius: 4px;
      border-top-left-radius: 4px;
      background-color: #ebebeb;
      padding: 11px 17px 12px;
    }
  }
}
</style>
